export default {
  name: "නම",
  tel: "දුරකථන",
  save: "සුරකින්න",
  confirm: "තහවුරු කරන්න",
  cancel: "අවලංගු කරන්න",
  delete: "මකන්න",
  complete: "අවසන්",
  loading: "පැටවීම ...",
  telEmpty: "කරුණාකර ඔබගේ දුරකථන අංකය පුරවන්න",
  nameEmpty: "කරුණාකර ඔබේ නම පුරවන්න",
  nameInvalid: "කරුණාකර වලංගු නමක් ඇතුළත් කරන්න",
  confirmDelete: "ඔබට එය මකා දැමීමට අවශ්ය බව ඔබට විශ්වාසද?",
  telInvalid: "කරුණාකර නිවැරදි දුරකථන අංකය ඇතුළත් කරන්න",
  vanCalendar: {
    end: "අවසන්",
    start: "ආරම්භ කරන්න",
    title: "මාතෘකාව",
    confirm: "තහවුරු කරන්න",
    startEnd: "ආරම්භක අවසානය",
    weekdays: {
      "0": "දවස",
      "1": "එකක්",
      "2": "දෙකක්",
      "3": "තුනක්",
      "4": "හතර",
      "5": "පහක්",
      "6": "හය"
    }
  },
  vanCascader: { select: "කරුණාකර තෝරන්න" },
  vanContactCard: { addText: "ස්පර්ශයක් එක් කරන්න" },
  vanContactList: { addText: "නව සම්බන්ධතා පුද්ගලයා" },
  vanPagination: { prev: "පෙර පිටුව", next: "ඊළඟ පිටුව" },
  vanPullRefresh: {
    pulling: "නැවුම් කිරීමට පහළට අදින්න ...",
    loosing: "මුදා හැරීම නැවුම්බව ..."
  },
  vanSubmitBar: { label: "සියල්ල:" },
  vanCoupon: { unlimited: "භාවිත සීමා කිරීම් නොමැත" },
  vanCouponCell: { title: "කූපන් පත්", tips: "ලද නොහැක" },
  vanCouponList: {
    empty: "කූපන් පත් නොමැත",
    exchange: "හුවමාරුව",
    close: "කූපන් පත් නොමැත",
    enable: "ලබා ගත හැකිය",
    disabled: "ලද නොහැක",
    placeholder: "කරුණාකර වට්ටම් කේතය ඇතුළත් කරන්න"
  },
  vanAddressEdit: {
    area: "ප්රදේශය",
    postal: "තැපැල් කේතය",
    areaEmpty: "කලාපයක් තෝරන්න",
    addressEmpty: "කරුණාකර සවිස්තරාත්මක ලිපිනය පුරවන්න",
    postalEmpty: "තැපැල් කේත ආකෘතිය වැරදිය",
    defaultAddress: "පෙරනිමි නැව්ගත කිරීමේ ලිපිනය ලෙස සකසන්න",
    telPlaceholder: "Compneee ජංගම දුරකථන අංකය",
    namePlaceholder: "තොගකරුගේ නම",
    areaPlaceholder: "පළාතක් / නගරයක් / දිස්ත්රික්කයක් තෝරන්න"
  },
  vanAddressEditDetail: {
    label: "ලිපිනය",
    placeholder: "වීදි දොර අංකය, බිම් කාමර අංකය සහ වෙනත් තොරතුරු"
  },
  vanAddressList: { add: "ලිපිනයක් එක් කරන්න" }
};
